import { GetFilesParams } from "./file.types";

export const FILE_KEYS = {
  all: ["files"] as const,
  lists: () => [...FILE_KEYS.all, "list"] as const,
  list: (params?: GetFilesParams) => [...FILE_KEYS.lists(), params] as const,
  details: () => [...FILE_KEYS.all, "detail"] as const,
  detail: (id: string) => [...FILE_KEYS.details(), id] as const,
  myFiles: (params?: GetFilesParams) =>
    [...FILE_KEYS.all, "my-files", params] as const,
};